import { Grid, Typography } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'
import LayoutPage from 'src/components/page-layout/layout-page'
import { FTRADER_PROXY_URL } from 'src/settings'

const FixedIncomeCalculatorPage = () => {
    const [cookieSet, setCookieSet] = useState(false)
    const iframeRef = useRef(null)

    useEffect(() => {
        const jwt = localStorage.getItem('jwt')
        if (jwt) {
            document.cookie = `c2p_jwt=${jwt}; domain=.c2ps.com.br; path=/`
            // document.cookie = `c2p_jwt=${jwt}; domain=.c2ps.localhost; path=/`
        }
        setCookieSet(true)
    }, [])

    return (
        <LayoutPage title="Títulos Privados">
            <>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography variant="h4">Títulos Privados</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item sx={{ width: '100%', mt: { md: 6, xs: 0 }}}>
                        {cookieSet && (
                            <iframe 
                                ref={iframeRef}
                                src={`${FTRADER_PROXY_URL}/cadastrotituloembed.aspx`}
                                width="100%" 
                                style={{ border: 'none', height: '100vh' }}
                            />
                        )}
                    </Grid>
                </Grid>
            </>
        </LayoutPage>
    )
}

export default FixedIncomeCalculatorPage
